/* eslint-disable */
import { Table, DatePicker, Flex, Radio } from "antd";
import React, { forwardRef, useEffect, useState } from "react";
import commonFn from "@/utils/commonFn";
import { Typography } from "antd";
const { Text, Link } = Typography;
import http from "@/utils/http";
import api from "@/utils/api";
import { SyncOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;

const MaintenceMain = forwardRef(() => {
  const [error, setError] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [tableoading, setTableLoading] = useState(false);
  const handlRequestCountClick = (record) => {
    if (record.requestCount === 0) {
      return;
    }
    console.log("Requests,", record);
    const params = { ids: record.requestIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlpendingCountClick = (record) => {
    if (record.pendingCount === 0) {
      return;
    }
    const params = { ids: record.pendingIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlAssignedCountClick = (record) => {
    if (record.assginedCount === 0) {
      return;
    }
    const params = { ids: record.assginedIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlQuotedCountClick = (record) => {
    if (record.quotedCount === 0) {
      return;
    }
    const params = { ids: record.quotedIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlApprovedCountClick = (record) => {
    if (record.approvedCount === 0) {
      return;
    }
    const params = { ids: record.approvedIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlReviewCountClick = (record) => {
    if (record.reviewCount === 0) {
      return;
    }
    const params = { ids: record.reviewIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handlOverRequestCountCountClick = (record) => {
    if (record.overRequestCount === 0) {
      return;
    }
    const params = { ids: record.overRequestIds };
    const baseUrl = window.location.origin;
    const route = "/JobRequests/Maintenance";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
 
 const handlCompletedCountClick = (record) => {
    if (record.completedCount === 0) {
      return;
    }
    const params = { ids: record.completedIds };
    const baseUrl = window.location.origin;
 const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

   const handlSignatureCounClick = (record) => {
    if (record.completedWithoutSignatureCount === 0) {
      return;
    }
    const params = { ids: record.completedWithoutSignatureIds };
    const baseUrl = window.location.origin;
   const route = "/JobRequests/MaintenanceHistory";
    const paramString = new URLSearchParams(params).toString();
    const hash = `${route}${paramString ? `?${paramString}` : ""}`;
    const url = `${baseUrl}#${hash}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };
  // 格式化 count
  const formatCount = (count) => {
    if (count === null || count === undefined) return "-";
    return Number(count) === 0 ? "-" : count;
  };

  // 公共渲染函数
  const renderCountCell = (text, record, handler) => {
    const value = formatCount(text);
    return (
      <span
        style={{
          color: value === "-" ? "inherit" : "#0e78a9",
          // textDecoration: value === "-" ? "none" : "underline",
          cursor: value === "-" ? "default" : "pointer",
        }}
        onClick={() => value !== "-" && handler(record)}
      >
        {value}
      </span>
    );
  };
  const initColumns = [
    {
      title: "Supervisor Name",
      dataIndex: "supervisorName",
      key: "supervisorName",
      hidden: false,
      width: 300,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text) => text,
    },
    {
      title: "Total Outstanding Requests",
      dataIndex: "requestCount",
      key: "requestCount",
      hidden: false,
      width: 200,
      align: "center",
      render: (text, record) =>
        renderCountCell(text, record, handlRequestCountClick),
    },
    {
      title: "Total Not Assigned",
      dataIndex: "pendingCount",
      key: "pendingCount",
      hidden: false,
      width: 300,
      align: "center",
      render: (text, record) =>
        renderCountCell(text, record, handlpendingCountClick),
    },
    {
      title: "Total Assigned",
      dataIndex: "assginedCount",
      key: "assginedCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlRequestCountClick),
    },
    {
      title: "Total Quoted",
      dataIndex: "quotedCount",
      key: "quotedCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlQuotedCountClick),
    },
    {
      title: "Total Approved To Work",
      dataIndex: "approvedCount",
      key: "approvedCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlApprovedCountClick),
    },
    {
      title: "Total Need Review",
      dataIndex: "reviewCount",
      key: "reviewCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlReviewCountClick),
    },
    {
      title: "Total Passed Predicted Completion Date",
      dataIndex: "overRequestCount",
      key: "overRequestCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlOverRequestCountCountClick),
    },
      {
      title: "Total Completed",
      dataIndex: "completedCount",
      key: "completedCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlCompletedCountClick),
    },
      {
      title: "Completed Without Signature",
      dataIndex: "completedWithoutSignatureCount",
      key: "completedWithoutSignatureCount",
      hidden: false,
      width: 200,
      align: "center",
      isSorter: true,
      sortterMultiple: 2,
      render: (text, record) =>
        renderCountCell(text, record, handlSignatureCounClick),
    },
  ];
  const [columns, setColumns] = useState(commonFn.handleColunmFn(initColumns));

  // 获取所有的report
  const reportAllData = async () => {
    try {
      setTableLoading(true);
      const response = await http.get(api.getAllReportList);
      const dataWithKey = (response.data || [])?.map((item) => ({
        ...item,
        key: item.accountId,
      }));
      // console.log("responsetable1", dataWithKey);
      setFilteredData(dataWithKey);
    } catch (err) {
      console.error("请求失败:", err);
      setError(err);
    } finally {
      setTableLoading(false);
    }
  };
  const showModalThree = () => {
    console.log("==========刷新按钮============");
    reportAllData();
  };
  // 初始化函数

  useEffect(() => {
    reportAllData();
  }, []);
  return (
    <div>
      <Flex className="topDiv" justify="space-between" align="flex-start">
        <div className="topLeft"> </div>
        <div>
          <Radio.Group defaultValue="a" size="middle">
            <Radio.Button value="a" onClick={showModalThree}>
              <SyncOutlined />
            </Radio.Button>
          </Radio.Group>
        </div>
      </Flex>
      <Table
        loading={tableoading}
        bordered={true}
        columns={columns.filter((col) => col.hidden === false)}
        dataSource={[...filteredData]}
        pagination={false}
        rowKey="accountId"
        scroll={{
          x: "max-content",
          y: "calc(100vh - 350px)",
        }}
        className="maintenance-report-Table"
      />
    </div>
  );
});
export default MaintenceMain;
